import gql from 'graphql-tag';

export default gql`
  mutation createOneHomeTaskMutation(
    $course: MongoID!
    $courseCategory: MongoID!
    $notes: String
    $title: String!
    $files: [MongoID]
  ) {
    createOneHomeTaskMutation(
      course: $course
      courseCategory: $courseCategory
      notes: $notes
      title: $title
      files: $files
    ) {
      message
      title
      record {
        creator {
          _id
        }
        course {
          _id
        }
        title
        notes
        _id
        createdAt
      }
    }
  }
`;
